import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../theme/nav.css";

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const user = JSON.parse(localStorage.getItem("user") || "null");

  const go = (path) => {
    if (location.pathname !== path) {
      navigate(path);
    }
  };

  const goProfile = () => {
    if (!user?.user_id) return;
    navigate(`/u/${user.user_id}`);
  };

  const openCreate = () => {

  const isMobile = window.innerWidth < 768;

  if (isMobile) {
    navigate("/create"); // open create page on mobile
  } else {
    const el = document.getElementById("composer");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  }

};

  return (
    <nav className="bottom-nav">

      <button
        className={`bn-item ${location.pathname === "/" ? "active" : ""}`}
        onClick={() => go("/")}
      >
        <span className="icon">🏠</span>
        <span className="label">Home</span>
      </button>

      <button
        className={`bn-item ${location.pathname.startsWith("/conversations") ? "active" : ""}`}
        onClick={() => go("/conversations")}
      >
        <span className="icon">💬</span>
        <span className="label">Chats</span>
      </button>

      <button
  className="bn-item create"
  onClick={openCreate}
>
        <span className="icon">＋</span>
      </button>

      <button
  className={`bn-item ${location.pathname.startsWith("/clips") ? "active" : ""}`}
  onClick={() => go("/clips")}
>
  <span className="icon">🎬</span>
  <span className="label">Clips</span>
</button>

      <button
        className={`bn-item ${location.pathname.startsWith(`/u/${user?.user_id}`) ? "active" : ""}`}
        onClick={goProfile}
      >
        <span className="icon">👤</span>
        <span className="label">Me</span>
      </button>

    </nav>
  );
}